import common from './en/common';
import message from './en/message';
import validation from './en/validation';
import auth from './en/auth';
import notification from './en/notification';
import user from './en/user';

const locales = {
  common,
  message,
  validation,
  auth,
  notification,
  user
};

export default locales;
